import { inject } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot
} from "@angular/router";
import { AuthService } from "../../../services/auth.service";

export const CanActivateAuthGuardFn: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const sessionStatus = authService.isValid();
    if (sessionStatus.isValid) {
        return true;
    }

    router.navigate(["/login"], {
        queryParams: { return: state.url, msg: sessionStatus.reason }
    });

    return false;
};
